import BaseModel from './BaseModel';
import Group from './Group';
import Invoice from './Invoice';
import StudentEnrolment from './StudentEnrolment';

/** Class representing an user. */
class Student extends BaseModel {
    constructor(properties) {
        super(properties);

        if ('enrolment' in this)
            this.enrolment = new StudentEnrolment(this.enrolment);

        if ('group' in this)
            this.group = new Group(this.group);

        if ('invoices' in this)
            this.invoices = (this.invoices || []).map(invoice => new Invoice(invoice));
    }
}

export default Student;
